import { Component, Input } from '@angular/core';

import { InsurancePlanAccumulatorsCoverage, Maybe } from '@genesis-frontend/graphql';

@Component({
    selector: 'accumulator-item',
    templateUrl: './accumulator-item.component.html',
    styleUrls: ['./accumulator-item.component.scss']
})
export class AccumulatorItemComponent {
    @Input() accumulator: Maybe<InsurancePlanAccumulatorsCoverage> = {} as Maybe<InsurancePlanAccumulatorsCoverage>;
}
